import(/* webpackMode: "eager", webpackExports: ["CandidatesView"] */ "/vercel/path0/src/app/doi-tac/ung-vien/candidates-view.tsx");
